// eslint-disable-next-line import/no-extraneous-dependencies
import html2pdf from 'html3pdf';

export type HtmlToPdfOptions = {
  filename: string;
  margin: number[];
  pagebreak: { mode: string };
  html2canvas: { scale: number };
  jsPDF: { unit: string; format: string; orientation: string };
};

export const convertHtmlToPdfBlob = async (
  html: string,
  pdfOptions: HtmlToPdfOptions
): Promise<Blob> =>
  html2pdf().from(html).set(pdfOptions).output('blob');
